import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToastMsg from "../../components/common/ToastMsg";
import { ImagePaths } from "../../utils/ImagePaths";
import { emailValidation } from "../../components/common/CommonFunctions";
import { SEND_OTP } from "../../constants/api";
import useApiMethods from "../../lib/useApiMethods";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { create } = useApiMethods();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onFinish = async (e) => {
    e.preventDefault();

    if (!email) {
      ToastMsg("error", "Registered email is required");
      return;
    }
    if (!emailValidation(null, email)) {
      ToastMsg("error", "Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const payload = { email };

      const response = await create(SEND_OTP, payload, false, setLoading, token);

      if (response?.status === "success") {
        ToastMsg("success", response.message || "OTP sent successfully");
        navigate("/otpverification", {
          state: { id: response.user_id, email },
        });
      } else {
        ToastMsg("error", response.message || "Something went wrong");
      }
    } catch (error) {
      ToastMsg("error", error.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center relative bg-gray-50 dark:bg-gray-900 font-sans">
      {/* Background */}
      <div
        className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2162167863/photo/businessman-in-the-logging-in-using-a-secure-web-page.jpg?s=1024x1024&w=is&k=20&c=Hc1J9SSw49Ekb4iTLfUJd-vL_Cicbl3WMlABp4yBLSE=')] 
        bg-cover bg-center opacity-20"
      />
      <div className="absolute inset-0 bg-white/40 dark:bg-black/40 backdrop-blur-sm" />

      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo.default}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        {/* Card */}
        <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-md rounded-xl shadow-xl p-6 animate-fadeIn">
          {/* Header */}
          <div className="flex items-center mb-4">
            <img
              src={ImagePaths.backArrow.default}
              alt="Back"
              className="h-5 w-5 cursor-pointer mr-2"
              onClick={() => navigate("/")}
            />
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              Forgot Password
            </h2>
          </div>

          <p className="text-[13px] text-gray-500 dark:text-gray-400 mb-5">
            Enter your registered email ID to receive an OTP.
          </p>

          {/* Form */}
          <form onSubmit={onFinish} className="space-y-4">
            <div>
              <label className="block text-[13px] font-medium text-gray-700 dark:text-gray-300 mb-1">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 text-[13px] rounded-lg border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 outline-none focus:ring-2 focus:ring-[#04b7b1] transition"
                placeholder="Enter your registered email"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-2 px-4 rounded-lg text-white font-semibold transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#04b7b1] hover:bg-[#04b7b1]/80 focus:ring-2 focus:ring-[#04b7b1] focus:ring-offset-2"
              }`}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
